import { render, staticRenderFns } from "./SyncingIndicator.vue?vue&type=template&id=56e9741b&scoped=true"
import script from "./SyncingIndicator.vue?vue&type=script&lang=js"
export * from "./SyncingIndicator.vue?vue&type=script&lang=js"
import style0 from "./SyncingIndicator.vue?vue&type=style&index=0&id=56e9741b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e9741b",
  null
  
)

export default component.exports